import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface SimpleCollapseProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export const SimpleCollapse = React.forwardRef<HTMLDivElement, SimpleCollapseProps>(
  ({ title, defaultOpen = false, className, children, ...props }, ref) => {
    const [isOpen, setIsOpen] = React.useState(defaultOpen);

    return (
      <div ref={ref} className={cn("w-full", className)} {...props}>
        <Button
          type="button"
          variant="ghost"
          onClick={() => setIsOpen(!isOpen)}
          className="flex w-full justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180"
          data-state={isOpen ? "open" : "closed"}
        >
          {title}
          <ChevronDown
            className="h-4 w-4 shrink-0 transition-transform duration-200"
            style={{
              transform: isOpen ? "rotate(180deg)" : undefined,
            }}
          />
        </Button>
        <div
          className={cn(
            "overflow-hidden transition-all duration-200",
            isOpen ? "animate-collapse-down" : "animate-collapse-up h-0"
          )}
        >
          {children}
        </div>
      </div>
    );
  }
);

SimpleCollapse.displayName = "SimpleCollapse"; 